import {ShareService} from './layout/share/services/share.service';
import {AfterViewInit, Component, OnInit, Renderer2} from '@angular/core';
import {Geolocation} from '@ionic-native/geolocation/ngx';
import {Platform} from '@ionic/angular';
import {environment} from '../environments/environment';
import {isMobile} from './helpers/tracking-teko';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {

  constructor(
    private geolocation: Geolocation,
    private shareService: ShareService,
    public platform: Platform,
    private renderer2: Renderer2,
    private route: ActivatedRoute,
  ) {
    // let location: any = {};
    // this.geolocation.getCurrentPosition()
    // .then(
    //   (resp) => {
    //   location.lat = resp.coords.latitude;
    //   location.lon = resp.coords.longitude;
    //   localStorage.setItem('location', JSON.stringify(location));
    // })
    // .catch((error) => {
    //   console.log('Error getting location', error);
    //   localStorage.removeItem('location');
    // });
  }

  isShowCDN = false;

  ngOnInit(): void {
    // this.addTrackingId();
    this.addIframe();
    this.addReCaptcha();

    // // Tích hợp iframe
    // (window as any).track('hookMessage', (body) => {
    //   console.log('messeage', body);
    // });
    //
    // // end
  }

  addIframe() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.src = `https://unpkg.com/loyalty-module@${environment.versionCDN}/check-code/check-code.loyalty.js`;
    document.getElementsByTagName('head')[0].appendChild(s);

    const l = this.renderer2.createElement('link');
    l.type = 'text/css';
    l.rel = 'stylesheet';
    l.href = `https://unpkg.com/loyalty-module@${environment.versionCDN}/check-code/check-code.loyalty.css`;
    document.getElementsByTagName('head')[0].appendChild(l);
  }

  addReCaptcha() {
    const script = this.renderer2.createElement('script');
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${environment.keyCaptcha}`;
    script.async = true;
    script.defer = true;
    // this.renderer.appendChild(this.document.head, script);
    document.getElementsByTagName('head')[0].appendChild(script);
  }

  // addTrackingId() {
  //   const s = this.renderer2.createElement('script');
  //   s.type = 'text/javascript';
  //   s.text = `
  //     !function(t,e,r,n,s,a,o,c){t[s]||(t.GlobalTrackerNamespace=t.GlobalTrackerNamespace||[],t.GlobalTrackerNamespace.push(s),t.GlobalTrackerNamespace.push("https://tracking.tekoapis.com"),t[s]=function(){(t[s].q=t[s].q||[]).push(arguments)},t[s].q=t[s].q||[],(o=e.createElement(r)).async=!0,o.src=n,(c=e.getElementsByTagName(r)[0]).parentNode.insertBefore(o,c),window.onerror=function(e,r,a,o,c){if(r===n)return t[s]("exception",{msg:e,error:c}),!1})}(window,document,"script","https://cdn.tekoapis.com/tracker/dist/v2/tracker.full.min.js","track");
  //     track("init", '${isMobile() ? environment.tracking_id_mobile : environment.tracking_id_web}' )
  //     track("enableLinkClick");
  //     track('enableSubmitForm');
  //     track('enableFocusForm');
  //   `;
  //   document.getElementsByTagName('head')[0].appendChild(s);
  // }
  ngAfterViewInit(): void {

    // this.route.queryParams
    //     .subscribe(params => {
    //           if ((params?.parent_campaign_id || params?.campaignId) && params?.isIframe) {
    //             this.isShowCDN = true;
    //             (window as any).checkCampaign(params?.parent_campaign_id || params?.campaignId, null, null, null);
    //           }
    //         }
    //     );
    this.shareService.totalCDN.subscribe(change => {
      setTimeout(() => {
        if (change) {
          // dùng cho marketing
          const linkMKT = this.shareService.metadata.getValue();
          this.isShowCDN = true;
          (window as any).checkCampaign(this.shareService.campaignIdCdn.getValue(), null, null, linkMKT ? [
            {key: 'source', value: 'qr_mkt'},
            {key: 'target_type', value: 'qr_mar'},
            {key: 'requestId', value: linkMKT},
            {key: 'target', value: linkMKT}
          ] : null);
        }
      }, 1000);
    });
  }

  //  isMobile() {
  //   try { document.createEvent('TouchEvent'); return true; }
  //   catch (e) { return false; }
  // }
}
